import { useFormikContext } from 'formik'
import { AppointmentFormData } from '../types'
import { useParams } from 'react-router-dom'
import React, { FC, useEffect, PropsWithChildren } from 'react'

export const AppointmentFormWorkflow: FC<PropsWithChildren> = ({ children }) => {
  const params = useParams<{ userId?: string }>()
  const { setFieldValue } = useFormikContext<AppointmentFormData>()

  useEffect(() => {
    setFieldValue('clientId', params.userId || '')
  }, [params.userId, setFieldValue])

  return <>{children}</>
}
